<main id="new-account-main-content">
  <div class="page-container">
    <div class="column left" *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP'">
      <div class="texts-container">
        <h1 class="main-title-text" [innerHTML]="'NEW_ACCOUNT.MAIN_TITLE' | translate" #mainTitleText></h1>
      </div>
    </div>
    <ng-container *ngIf="APIAvailable; else ApiNotAvailable">
      <div
        class="column right"
        *ngIf="currentUserLang && (loadingSelfRegisterActive$ | async) === false; else userLangLoader">
        <div class="utils-buttons-wrapper">
          <app-utils-buttons (userLangChanged)="userLangChanged($event)"></app-utils-buttons>
        </div>

        <div class="logo">
          <img src="https://kartapobytu.app/img/logo.png" [alt]="'COMMON.ALTS.LOGO' | translate" />
        </div>

        <!-- OPEN REGISTRATION DISABLED -->
        <div class="content-column" *ngIf="!selfRegisterActive">
          <div class="row-wrapper inactive-registration">
            <div nz-row>
              <div nz-col [nzXs]="23" [nzSm]="23" [nzMd]="21">
                <div class="form-title" [innerHTML]="'NEW_ACCOUNT.REGISTRATION_TEMPORARILY_INACTIVE' | translate"></div>
              </div>
            </div>
            <div nz-row>
              <div nz-col [nzXs]="23" [nzSm]="23" [nzMd]="21">
                <div class="explanation-text" [innerHTML]="'NEW_ACCOUNT.SORRY_COMEBACK_LATER' | translate"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- FORM -->
        <div class="content-column" *ngIf="!registrationFinished && selfRegisterActive">
          <!-- GRAPHIC DOT AND FORM TITLE -->
          <div class="row-wrapper">
            <div nz-row>
              <div
                nz-col
                [nzXs]="labelW.xs"
                [nzSm]="labelW.sm"
                [nzMd]="labelW.md"
                [nzLg]="labelW.lg"
                [nzXl]="labelW.xl"
                [nzXXl]="labelW.xxl"></div>
              <div
                nz-col
                [nzXs]="inputW.xs"
                [nzSm]="inputW.sm"
                [nzMd]="inputW.md"
                [nzLg]="inputW.lg"
                [nzXl]="inputW.xl"
                [nzXXl]="inputW.xxl"></div>
            </div>
            <div nz-row>
              <div
                nz-col
                [nzXs]="labelW.xs"
                [nzSm]="labelW.sm"
                [nzMd]="labelW.md"
                [nzLg]="labelW.lg"
                [nzXl]="labelW.xl"
                [nzXXl]="labelW.xxl"></div>
              <div
                nz-col
                [nzXs]="inputW.xs"
                [nzSm]="inputW.sm"
                [nzMd]="inputW.md"
                [nzLg]="inputW.lg"
                [nzXl]="inputW.xl"
                [nzXXl]="inputW.xxl">
                <div class="form-title">{{ 'NEW_ACCOUNT.REGISTER_MYSELF' | translate }}</div>
              </div>
            </div>
          </div>
          <!-- FORM -->
          <form nz-form [formGroup]="newAccountForm" class="row-wrapper">
            <!-- FIRST NAME -->
            <nz-form-item>
              <nz-form-label
                [nzXs]="labelW.xs"
                [nzSm]="labelW.sm"
                [nzMd]="labelW.md"
                [nzLg]="labelW.lg"
                [nzXl]="labelW.xl"
                [nzXXl]="labelW.xxl"
                nzRequired
                nzFor="name">
                {{ 'COMMON.LABEL.FIRST_NAME' | translate }}
              </nz-form-label>
              <nz-form-control
                [nzXs]="inputW.xs"
                [nzSm]="inputW.sm"
                [nzMd]="inputW.md"
                [nzLg]="inputW.lg"
                [nzXl]="inputW.xl"
                [nzXXl]="inputW.xxl"
                [nzErrorTip]="errorTpl"
                aria-live="assertive"
                nzHasFeedback>
                <input
                  nz-input
                  required
                  id="name"
                  type="text"
                  formControlName="name"
                  autocomplete="given-name"
                  (focus)="scrollToInput($event)"
                  [attr.aria-invalid]="
                    newAccountForm.controls.name.invalid && newAccountForm.controls.name.touched ? 'true' : null
                  " />
              </nz-form-control>
            </nz-form-item>

            <!-- SURNAME -->
            <nz-form-item>
              <nz-form-label
                [nzXs]="labelW.xs"
                [nzSm]="labelW.sm"
                [nzMd]="labelW.md"
                [nzLg]="labelW.lg"
                [nzXl]="labelW.xl"
                [nzXXl]="labelW.xxl"
                nzRequired
                nzFor="surname">
                {{ 'COMMON.LABEL.SURNAME' | translate }}
              </nz-form-label>
              <nz-form-control
                [nzXs]="inputW.xs"
                [nzSm]="inputW.sm"
                [nzMd]="inputW.md"
                [nzLg]="inputW.lg"
                [nzXl]="inputW.xl"
                [nzXXl]="inputW.xxl"
                [nzErrorTip]="errorTpl"
                aria-live="assertive"
                nzHasFeedback>
                <input
                  nz-input
                  required
                  id="surname"
                  type="text"
                  formControlName="surname"
                  autocomplete="family-name"
                  (focus)="scrollToInput($event)"
                  [attr.aria-invalid]="
                    newAccountForm.controls.surname.invalid && newAccountForm.controls.surname.touched ? 'true' : null
                  " />
              </nz-form-control>
            </nz-form-item>

            <!-- EMAIL -->
            <nz-form-item>
              <nz-form-label
                [nzXs]="labelW.xs"
                [nzSm]="labelW.sm"
                [nzMd]="labelW.md"
                [nzLg]="labelW.lg"
                [nzXl]="labelW.xl"
                [nzXXl]="labelW.xxl"
                nzRequired
                nzFor="email">
                {{ 'COMMON.LABEL.EMAIL' | translate }}
              </nz-form-label>
              <nz-form-control
                [nzXs]="inputW.xs"
                [nzSm]="inputW.sm"
                [nzMd]="inputW.md"
                [nzLg]="inputW.lg"
                [nzXl]="inputW.xl"
                [nzXXl]="inputW.xxl"
                [nzErrorTip]="errorTpl"
                aria-live="assertive"
                nzHasFeedback>
                <input
                  nz-input
                  required
                  id="email"
                  type="email"
                  formControlName="email"
                  autocomplete="email"
                  (focus)="scrollToInput($event)"
                  [attr.aria-invalid]="
                    newAccountForm.controls.email.invalid && newAccountForm.controls.email.touched ? 'true' : null
                  " />
              </nz-form-control>
            </nz-form-item>

            <!-- CONFIRM EMAIL -->
            <nz-form-item>
              <nz-form-label
                [nzXs]="labelW.xs"
                [nzSm]="labelW.sm"
                [nzMd]="labelW.md"
                [nzLg]="labelW.lg"
                [nzXl]="labelW.xl"
                [nzXXl]="labelW.xxl"
                nzRequired
                nzFor="confirmEmail">
                {{ 'COMMON.LABEL.CONFIRM_EMAIL' | translate }}
              </nz-form-label>
              <nz-form-control
                [nzXs]="inputW.xs"
                [nzSm]="inputW.sm"
                [nzMd]="inputW.md"
                [nzLg]="inputW.lg"
                [nzXl]="inputW.xl"
                [nzXXl]="inputW.xxl"
                [nzErrorTip]="errorTpl"
                aria-live="assertive"
                nzHasFeedback>
                <input
                  nz-input
                  required
                  id="confirmEmail"
                  type="email"
                  autocomplete="false"
                  formControlName="confirmEmail"
                  (focus)="scrollToInput($event)"
                  [attr.aria-invalid]="
                    newAccountForm.controls.confirmEmail.invalid && newAccountForm.controls.confirmEmail.touched
                      ? 'true'
                      : null
                  " />
              </nz-form-control>
            </nz-form-item>

            <!-- PHONE NUMBER -->
            <nz-form-item>
              <nz-form-label
                [nzXs]="labelW.xs"
                [nzSm]="labelW.sm"
                [nzMd]="labelW.md"
                [nzLg]="labelW.lg"
                [nzXl]="labelW.xl"
                [nzXXl]="labelW.xxl"
                nzRequired
                nzFor="mobile">
                {{ 'COMMON.LABEL.PHONE_NUMBER' | translate }}
              </nz-form-label>
              <nz-form-control
                [nzXs]="inputW.xs"
                [nzSm]="inputW.sm"
                [nzMd]="inputW.md"
                [nzLg]="inputW.lg"
                [nzXl]="inputW.xl"
                [nzXXl]="inputW.xxl"
                [nzErrorTip]="errorTpl"
                aria-live="assertive"
                nzHasFeedback>
                <input
                  nz-input
                  required
                  id="mobile"
                  type="text"
                  formControlName="telephoneNumber"
                  autocomplete="tel"
                  inputmode="numeric"
                  pattern="^\+?[0-9]*$"
                  (keypress)="allowPhoneChars($event)"
                  (focus)="scrollToInput($event)"
                  [attr.aria-invalid]="
                    newAccountForm.controls.telephoneNumber.invalid && newAccountForm.controls.telephoneNumber.touched
                      ? 'true'
                      : null
                  " />
              </nz-form-control>
            </nz-form-item>

            <nz-form-item>
              <nz-form-label
                *ngIf="deviceInfo.deviceTypeDetected !== 'PHONE'"
                [nzNoColon]="true"
                [nzXs]="labelW.xs"
                [nzSm]="labelW.sm"
                [nzMd]="labelW.md"
                [nzLg]="labelW.lg"
                [nzXl]="labelW.xl"
                [nzXXl]="labelW.xxl">
              </nz-form-label>
              <nz-form-control
                [nzXs]="inputW.xs"
                [nzSm]="inputW.sm"
                [nzMd]="inputW.md"
                [nzLg]="inputW.lg"
                [nzXl]="inputW.xl"
                [nzXXl]="inputW.xxl">
                <div class="custom-checkbox">
                  <mat-checkbox formControlName="hasAcceptedGDPR" class="terms-label" aria-labelledby="gdprLabel">
                  </mat-checkbox>

                  <p id="gdprLabel" class="terms-text">
                    {{ 'NEW_ACCOUNT.TOS_GDPR_ACCEPTANCE.STEP_1_CONFIRM' | translate }}
                    <a target="_blank" rel="noopener" [href]="'COMMON.LINKS.TOS' | translate">
                      {{ 'NEW_ACCOUNT.TOS_GDPR_ACCEPTANCE.TOS' | translate }}
                    </a>
                    {{ 'NEW_ACCOUNT.TOS_GDPR_ACCEPTANCE.STEP_2_OR' | translate }}
                    <a target="_blank" rel="noopener" [href]="'COMMON.LINKS.PRIVACY_POLICY' | translate">
                      {{ 'NEW_ACCOUNT.TOS_GDPR_ACCEPTANCE.PRIVACY_POLICY' | translate }}
                    </a>
                    {{ 'NEW_ACCOUNT.TOS_GDPR_ACCEPTANCE.STEP_3_ACCEPT' | translate }}
                  </p>
                </div>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item>
              <nz-form-label
                *ngIf="deviceInfo.deviceTypeDetected !== 'PHONE'"
                [nzNoColon]="true"
                [nzXs]="labelW.xs"
                [nzSm]="labelW.sm"
                [nzMd]="labelW.md"
                [nzLg]="labelW.lg"
                [nzXl]="labelW.xl"
                [nzXXl]="labelW.xxl">
              </nz-form-label>
              <nz-form-control
                [nzXs]="inputW.xs"
                [nzSm]="inputW.sm"
                [nzMd]="inputW.md"
                [nzLg]="inputW.lg"
                [nzXl]="inputW.xl"
                [nzXXl]="inputW.xxl">
                <mat-checkbox formControlName="hasAcceptedDataProcessing" class="terms-label complex">
                  <span
                    [innerHTML]="
                      termsAcceptanceShownFully
                        ? ('NEW_ACCOUNT.DATA_PROCESSING_ACCEPTANCE' | translate)
                        : ('NEW_ACCOUNT.DATA_PROCESSING_ACCEPTANCE_SHORT' | translate)
                    ">
                  </span>
                  <button
                    type="button"
                    class="suffix-text"
                    (click)="termsAcceptanceShownFully = !termsAcceptanceShownFully"
                    [innerHTML]="'NEW_ACCOUNT.SHOW_FULL_ACCEPTANCE_CONTENT' | translate"></button>
                </mat-checkbox>
              </nz-form-control>
            </nz-form-item>
          </form>

          <!-- SPINNER ONLOADING SERVER_RESPONSE -->
          <div class="row-wrapper" *ngIf="loading$ | async">
            <div nz-row>
              <div
                nz-col
                [nzXs]="labelW.xs"
                [nzSm]="labelW.sm"
                [nzMd]="labelW.md"
                [nzLg]="labelW.lg"
                [nzXl]="labelW.xl"
                [nzXXl]="labelW.xxl"></div>
              <div
                nz-col
                [nzXs]="inputW.xs"
                [nzSm]="inputW.sm"
                [nzMd]="inputW.md"
                [nzLg]="inputW.lg"
                [nzXl]="inputW.xl"
                [nzXXl]="inputW.xxl"
                class="loading-container">
                <mat-spinner [diameter]="45"></mat-spinner>
              </div>
            </div>
          </div>
          <!-- SERVER ERROR MESSAGE -->
          <div class="row-wrapper" *ngIf="newAccountForm.invalid && (errorMessage$ | async) as errorMessage">
            <div nz-row>
              <!-- <div
              nz-col
              [nzXs]="labelW.xs"
              [nzSm]="labelW.sm"
              [nzMd]="labelW.md"
              [nzLg]="labelW.lg"
              [nzXl]="labelW.xl"
              [nzXXl]="labelW.xxl"></div> -->
              <div class="server-error-message" nz-col [nzSpan]="24">
                <p [innerHTML]="'COMMON.ERROR.' + errorMessage | translate: { email: lastUsedData.email }"></p>
              </div>
            </div>
          </div>
          <!-- REGISTER BUTTON + I ALREADY HAVE ACCOUNT LINK -->
          <div class="row-wrapper">
            <div nz-row>
              <div
                nz-col
                [nzXs]="labelW.xs"
                [nzSm]="labelW.sm"
                [nzMd]="labelW.md"
                [nzLg]="labelW.lg"
                [nzXl]="labelW.xl"
                [nzXXl]="labelW.xxl"></div>
              <div
                nz-col
                [nzXs]="24"
                [nzSm]="24"
                [nzMd]="inputW.md"
                [nzLg]="inputW.lg"
                [nzXl]="inputW.xl"
                [nzXXl]="inputW.xxl">
                <button
                  (click)="sendForm()"
                  class="submit-button"
                  [disabled]="
                    newAccountForm.pristine ||
                    (newAccountForm.dirty && newAccountForm.invalid) ||
                    (loading$ | async) ||
                    (errorMessage$ | async) === 'SELF_REGISTRATION_CURRENTLY_UNAVAILABLE'
                  "
                  mat-raised-button
                  color="primary">
                  {{ 'NEW_ACCOUNT.REGISTER_MYSELF' | translate }}
                </button>
              </div>
            </div>
            <div nz-row class="login-page-link-row">
              <div
                nz-col
                [nzXs]="labelW.xs"
                [nzSm]="labelW.sm"
                [nzMd]="labelW.md"
                [nzLg]="labelW.lg"
                [nzXl]="labelW.xl"
                [nzXXl]="labelW.xxl"></div>
              <div
                nz-col
                [nzXs]="inputW.xs"
                [nzSm]="inputW.sm"
                [nzMd]="inputW.md"
                [nzLg]="inputW.lg"
                [nzXl]="inputW.xl"
                [nzXXl]="inputW.xxl">
                <a (click)="$event.preventDefault()" [routerLink]="['/login']">
                  {{ 'NEW_ACCOUNT.I_HAVE_ACCOUNT_LOGIN' | translate }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- REGISTRATION FINISHED MESSAGES -->
        <div class="content-column registration-finished-column" *ngIf="registrationFinished">
          <div class="row-wrapper">
            <div nz-row>
              <div nz-col [nzSpan]="24" class="account-created-text">
                {{ 'NEW_ACCOUNT.ACCOUNT_CREATED' | translate }}
              </div>
            </div>
            <div nz-row>
              <div nz-col [nzSpan]="24">
                <p class="next-steps-explanation" [innerHTML]="'NEW_ACCOUNT.ACTIVATION_EXPLANATION' | translate"></p>
                <p class="close-page-info" [innerHTML]="'NEW_ACCOUNT.YOU_CAN_CLOSE_THIS_PAGE' | translate"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-template #userLangLoader>
    <div class="column right">
      <mat-spinner [diameter]="35"></mat-spinner>
    </div>
  </ng-template>

  <ng-template #errorTpl let-control>
    <ng-container *ngIf="control.invalid">
      {{ control.errors | errorsFormatingAndTranslate }}
    </ng-container>
  </ng-template>

  <ng-template #ApiNotAvailable>
    <div class="column right">
      <div class="utils-buttons-wrapper">
        <app-utils-buttons (userLangChanged)="userLangChanged($event)"></app-utils-buttons>
      </div>
      <div class="content-column">
        <div class="form-title error-title">
          {{ 'COMMON.ERROR.NO_CONNECTION_WITH_SERVER' | translate }}
        </div>
        <div class="connection-error-block">
          <div class="subtitle" [innerHTML]="'COMMON.ERROR.CONNECTION_ERROR_EXPLANATION' | translate"></div>
          <ul>
            <li [innerHTML]="'COMMON.NOTIFICATION.WAIT_WE_WILL_TRY_TO_RECONNECT' | translate"></li>
            <li [innerHTML]="'COMMON.NOTIFICATION.CHECK_INTERNET_CONNECTION' | translate"></li>
            <li [innerHTML]="'COMMON.NOTIFICATION.CHECK_FIREWALL_SETTINGS' | translate"></li>
            <li [innerHTML]="'COMMON.NOTIFICATION.CONSULT_LOCAL_NETWORK_ADMIN' | translate"></li>
            <li [innerHTML]="'COMMON.NOTIFICATION.COMEBACK_LATER' | translate"></li>
          </ul>
        </div>
      </div>
    </div>
  </ng-template>
</main>
